import { FC } from 'react';

import { Typography } from '@mui/material';

interface IBusinessPlanSectionTitleProps {
  title: string;
}

export const BusinessPlanSectionTitle: FC<IBusinessPlanSectionTitleProps> = ({ title }) => {
  return <Typography variant="h5">{title}</Typography>;
};
